export default __webpack_public_path__ + "static/media/smartphone2.c836858e.svg";